import localFont from 'next/font/local';

const font = localFont({
    src: [
        {
            path: '../../public/fonts/SourceSans3-Regular.ttf',
            weight: '400',
            style: 'normal'
        },
        {
            path: '../../public/fonts/SourceSans3-Italic.ttf',
            weight: '400',
            style: 'italic'
        },
        {
            path: '../../public/fonts/SourceSans3-Medium.ttf',
            weight: '500',
            style: 'normal'
        },
        {
            path: '../../public/fonts/SourceSans3-SemiBold.ttf',
            weight: '600',
            style: 'normal'
        },
        {
            path: '../../public/fonts/SourceSans3-SemiBoldItalic.ttf',
            weight: '600',
            style: 'italic'
        },
        {
            path: '../../public/fonts/SourceSans3-Bold.ttf',
            weight: '700',
            style: 'normal'
        }
    ]
});

export default font;
